
import React, { useState } from 'react';
import WalletPreviewContainer from '@/components/customization/WalletPreviewContainer';
// import ChatInterface from '@/components/chat/ChatInterface'; // Временно закомментировано
import { WalletChatProvider } from '@/contexts/WalletChatContext';
import { SmartEditContextProvider } from '@/contexts/SmartEditContext';
import Header from '@/components/layout/Header';
import Footer from '@/components/layout/Footer';
import ThemeSelectorCoverflow from '@/components/customization/ThemeSelectorCoverflow';
import ThemeChat from '@/components/ai/ThemeChat';
import { useUserThemeLoader } from '@/hooks/useUserThemeLoader';
import ExportToIpfsButton from '@/components/wallet/ExportToIpfsButton';
import { useThemeStore } from '@/state/themeStore';
import MintedGallerySection from '@/components/wallet/MintedGallerySection';
import { Drawer, DrawerContent } from '@/components/ui/drawer';
import { MessageCircle } from 'lucide-react';
import { useIsMobile } from '@/hooks/use-mobile';

const WalletAlivePlayground = () => {
  // Load user theme from database when wallet connects
  useUserThemeLoader();
  
  const activeThemeId = useThemeStore(state => state.activeThemeId);
  const isMobile = useIsMobile();
  
  const [selectedElementFromPreview, setSelectedElementFromPreview] = useState<string>('');
  const [isChatOpen, setIsChatOpen] = useState(false);

  const handleElementSelectFromPreview = (elementSelector: string) => {
    setSelectedElementFromPreview(elementSelector);
    console.log('🎯 Element selected from preview:', elementSelector);
  };

  return (
    <WalletChatProvider>
      <SmartEditContextProvider>
        <div className="min-h-screen bg-gradient-to-br from-gray-900 via-black to-gray-900 flex flex-col">
        {/* Header */}
        <Header />
        
        {/* Mobile: Floating Chat Button + Drawer */}
        <div className="md:hidden">
          <button
            onClick={() => setIsChatOpen(true)}
            className="fixed bottom-6 right-6 z-50 w-14 h-14 bg-gradient-to-r from-purple-600 to-pink-600 rounded-full shadow-2xl flex items-center justify-center hover:scale-110 transition-transform"
            aria-label="Open chat"
          >
            <MessageCircle className="w-6 h-6 text-white" />
          </button>
          
          <Drawer open={isChatOpen} onOpenChange={setIsChatOpen}>
            <DrawerContent className="h-[85vh]">
              <ThemeChat />
            </DrawerContent>
          </Drawer>
        </div>
        
        {/* Desktop: Fixed Chat Panel - Right Side */}
        <div className="hidden md:block fixed right-4 top-20 bottom-4 w-[360px] z-40">
          <div className="h-full rounded-2xl border border-white/10 bg-black/40 backdrop-blur-sm shadow-xl overflow-hidden">
            <ThemeChat />
          </div>
        </div>
        
        {/* Main Content - responsive padding */}
        <main className="flex-grow pt-20 pb-6 px-4 sm:px-6 md:pr-[392px]">
          <div className="max-w-full mx-auto">
            {/* Title Section */}
            <div className="text-center mb-8">
              <h1 className="text-4xl font-bold text-white mb-2">
                <span className="bg-gradient-to-r from-purple-400 via-pink-500 to-purple-600 bg-clip-text text-transparent">
                  Wallet UI Customization Studio
                </span>
              </h1>
              <p className="text-gray-400 text-lg">
                AI-powered wallet interface customization with conversational interface
              </p>
              <div className="mt-2 inline-block bg-gradient-to-r from-purple-600/20 to-pink-600/20 backdrop-blur-sm border border-purple-500/30 text-white text-sm px-4 py-2 rounded-full">
                🤖 AI Chat Assistant + Real-time Preview
              </div>
            </div>

            {/* Main Layout - Single Column (chat is now fixed) */}
            <div className="mb-8">
              {/* Wallet Preview */}
              <WalletPreviewContainer 
                onElementSelect={handleElementSelectFromPreview}
              />
            </div>

            {/* MINT NFT Button - Between Preview and Coverflow */}
            <div className="flex justify-center items-center gap-4 mb-8">
              <ExportToIpfsButton 
                themeId={activeThemeId}
              />
            </div>
            
            {/* Theme Selector Coverflow */}
            <div className="bg-black/30 backdrop-blur-md border border-white/10 rounded-lg">
              <ThemeSelectorCoverflow />
            </div>

            {/* Minted Gallery Section */}
            <MintedGallerySection />
          </div>
        </main>

        {/* Footer - Will stick to bottom with mt-auto from flex layout */}
        <Footer />
        </div>
      </SmartEditContextProvider>
    </WalletChatProvider>
  );
};

export default WalletAlivePlayground;
